import React, { FC } from 'react';
import { Paper, Table, TableBody, TableContainer } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { observer } from 'mobx-react-lite';
import {useTable} from "../../../../../hooks/useTable";
import {MENSTRUAL_PHASES} from "../../../entity/MenstrualPhases";
import {MenstrualCyclesTableRow} from "../tableRow";


export const MenstrualCyclesTable: FC = observer(() => {
    const { t } = useUiContext();
    const { scrollRef } = useTable();

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ position: "relative" }} ref={scrollRef}>
                <Table>
                    <TableBody>
                        {MENSTRUAL_PHASES.map((item) => (<MenstrualCyclesTableRow type={item} key={item} />))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
})
